import React, { Fragment, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { translate } from "react-switch-lang";
import Box from "@mui/material/Box";
import { Step, Stepper } from "react-form-stepper";
import DatePicker from "react-datepicker";
import { Typeahead } from "react-bootstrap-typeahead";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useHttpClient } from "../../../security/hooks/axiosProvider";
import { toast } from "react-toastify";
import "./updateImagesGallery.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import styles from "./updateImagesGallery.module.scss";
import { Image } from "react-bootstrap";
import { ExpositionImageDto } from "../../../models/expositionImageDto";
import "./styleFormStep.css";
import { Col, Form, FormGroup, Label, ModalFooter, Row } from "reactstrap";
import DragSortableList from "react-drag-sortable";
import ImageUploading from "react-images-uploading";
import { ExpositionDto } from "../../../models/expositionDto";

const placeholder = <></>;
const UpdateImagesGallery = props => {
  toast.configure();
  const steps = [String(props.t("step_info")), String(props.t("step_description")), String(props.t("step_attachements"))];
  let thematicRef = React.useRef(null);
  const refDragSortable = React.createRef();
  const httpClient = useHttpClient(true);
  let countryRef = React.useRef(null);
  const [, setIsFomrValid] = useState(false);
  const [listOptionsCountry, setListOptionsCountry] = useState([]);
  const selectedLanguage = useSelector((state: RootState) => state.language.currentLang);
  const [listOptionsThematic, setListOptionsThematic] = useState([]);
  const [listOfImages, setListOfImages] = useState<any>([]);
  const [images, setImages] = React.useState([]);
  const maxNumber = 30;
  const [isFomrStepOneValid, setIsFomrStepOneValid] = useState(true);
  const { register, setValue, handleSubmit, getValues, control } = useForm({
    mode: "onChange",
    defaultValues: {
      dateSupport: props.exposition.dateExposition ? props.exposition.dateExposition : "2005",
      titleFr: props.exposition?.titleFr ? props.exposition.titleFr : "",
      titleEn: props.exposition?.titleEn ? props.exposition.titleEn : "",
      listThematic: props.exposition?.listThematic ? props.exposition.listThematic : [],
      country: props.exposition?.listCountry ? props.exposition.listCountry : [],
      descriptionFr: props.exposition?.descriptionFr ? props.exposition.descriptionFr : "",
      descriptionEn: props.exposition?.descriptionEn ? props.exposition.descriptionEn : "",
    },
  });
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());
  const [listOfImagesWillBeDeleted, setListOfImagesWillBeDeleted] = useState<any>([]);

  useEffect(() => {
    setListOfImagesWillBeDeleted([]);
    if (props.exposition.listExpositionImage.length !== 0) {
      handleIsFormValid("");
      setImages(props.exposition.listExpositionImage);
      ImagesSortable(props.exposition.listExpositionImage);
    }
    if (props.support) {
      setValue("dateSupport", props.support?.dateSupport);
    } else {
    }
    httpClient.current?.get("/country").then(response => {
      setListOptionsCountry(response.data);
    });
    httpClient.current?.get(`/country/${props.exposition.countryId}`).then(response => {});
    httpClient.current?.get("/thematic").then(response => {
      setListOptionsThematic(response.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [httpClient]);

  const handleChangeThematic = selectedOptions => {
    setValue("listThematic", selectedOptions);
    handleIsFormValid(selectedOptions);
    handleIsStepOneValid();
  };

  const handleChangeCountry = selectedOptions => {
    setValue("country", selectedOptions);
    handleIsFormValid(selectedOptions);
    handleIsStepOneValid();
  };

  const handleIsFormValid = element => {
    setIsFomrValid(
      getValues().titleEn !== "" &&
        getValues().titleFr !== "" &&
        getValues().descriptionFr !== "" &&
        getValues().descriptionEn !== "" &&
        getValues().country[0] !== "" &&
        getValues().listThematic.length !== 0 &&
        getValues().dateSupport !== "" &&
        props.exposition.listExpositionImage.length !== 0,
    );
  };

  const dropZoneIsValid = e => {
    setIsFomrValid(e.length !== 0);
  };

  const onChange = (imageList, addUpdateIndex) => {
    setImages(imageList);
    ImagesSortable(imageList);
    dropZoneIsValid(imageList);
  };

  const ImagesSortable = list => {
    let data: any[] = [];
    list.map((image, index) =>
      data.push({
        content: (
          <div key={index} className="col-4">
            <Image
              id={image["expositionImageId"] ? image["expositionImageId"] : null}
              className={styles["custom-img__drop-zone"]}
              src={image["data_url"] ? image["data_url"] : image["urlImage"]}
              alt="not found!"
            />
            <i
              style={{
                position: "absolute",
                top: "-3px",
                right: "-61px",
              }}
              onClick={() => {
                list.splice(index, 1);
                listOfImagesWillBeDeleted.push(image);
                ImagesSortable(list);
                dropZoneIsValid(list);
              }}
              className={`${styles["images-actions__btn-delete"]} fa fa-times`}
            ></i>
          </div>
        ),
      }),
    );
    setListOfImages(data);
  };

  const getRandomName = length => {
    let randomChars = "trSvpJRtRnyHj2xc";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result.concat(".png");
  };

  const onSortedListOfImg = (sortedList, dropEvent) => {};

  const _handleSubmit = async data => {
    let listExpositionImage: ExpositionImageDto[] = [];
    let imagesSrc = document.querySelectorAll(".draggable > div > img");
    for (let index = 0; index < imagesSrc.length; index++) {
      let responseData;
      if (!imagesSrc[index].hasAttribute("id")) {
        let formData = new FormData();
        formData.append("file", dataURLtoFile(imagesSrc[index].getAttribute("src"), getRandomName(10)));
        formData.append("exposition_name", props?.path);
        formData.append("rank", index.toString());
        responseData = await httpClient.current?.post(`/exposition-image/upload/`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        // exposition image already exist
        responseData = await httpClient.current?.put(
          `/exposition-image/${imagesSrc[index].getAttribute("id")}/${index.toString()}`,
          {},
          {
            headers: { "Content-Type": "application/json" },
          },
        );
      }
      listExpositionImage.push(responseData.data);
    }
    let exposition: ExpositionDto = new ExpositionDto();
    exposition.expositionId = props.exposition.expositionId;
    exposition.countryId = data?.country[0]?.countryId;
    exposition.listExpositionImage = listExpositionImage;
    exposition.dateExposition = data.dateSupport;
    exposition.categoryId = props?.categoryId;
    exposition.descriptionEn = data.descriptionEn;
    exposition.descriptionFr = data.descriptionFr;
    exposition.titleFr = data.titleFr;
    exposition.titleEn = data.titleEn;
    exposition.listThematic = data.listThematic;
    exposition.expositionESId = props?.exposition?.expositionESId;
    httpClient.current?.put(`/exposition`, exposition).then(response => {
      props.onUpdate();
      props.closeToggle();
      props.resetAllFieldSearch();
    });
    listOfImagesWillBeDeleted.map((i, index: number) => {
      return httpClient.current?.delete(`/exposition-image/list-exposition-image/${i.expositionImageId}`).then(response => {});
    });
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep(prevActiveStep => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const dataURLtoFile = (dataurl, filename) => {
    let arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleIsStepOneValid = () => {
    setIsFomrStepOneValid(getValues().titleEn !== "" && getValues().titleFr !== "" && getValues().country[0] !== "" && getValues().listThematic.length !== 0 && getValues().dateSupport !== "");
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Stepper className="p-0" activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps: { completed?: boolean } = {};
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }

          return <Step label={label} key={label} {...stepProps}></Step>;
        })}
      </Stepper>
      {activeStep === steps.length ? (
        <></>
      ) : (
        <React.Fragment>
          <Fragment>
            <Form onSubmit={handleSubmit(_handleSubmit)} className="card m-b-0 p-t-30">
              <div className="ml-3 mr-3">
                {activeStep === 0 ? (
                  <>
                    <Row className={styles["zone-step-exposition"]}>
                      <Col lg="6">
                        <FormGroup className="m-b-30">
                          <Label id="title_fr" className="form-label">
                            {props.t("expo_modale.label_name_fr")}*
                          </Label>
                          <input
                            {...register("titleFr")}
                            required
                            onChange={event => {
                              setValue("titleFr", event.target.value);
                              handleIsFormValid(event.target.value);
                              handleIsStepOneValid();
                            }}
                            maxLength={100}
                            className="form-control"
                            type="text"
                            placeholder={props.t("expo_modale.label_name_fr")}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup className="m-b-30">
                          <Label id="title_en" className="form-label">
                            {props.t("expo_modale.label_name_en")}*
                          </Label>
                          <input
                            {...register("titleEn")}
                            required
                            onChange={event => {
                              setValue("titleEn", event.target.value);
                              handleIsFormValid(event.target.value);
                              handleIsStepOneValid();
                            }}
                            maxLength={100}
                            className="form-control"
                            type="text"
                            placeholder={props.t("expo_modale.label_name_en")}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <FormGroup className="m-b-30">
                          <Label id="date" className="form-label">
                            {props.t("expo_modale.label_date")}*
                          </Label>{" "}
                          <br />
                          <Controller
                            control={control}
                            name="dateSupport"
                            rules={{ required: true }}
                            render={({ field: { onChange } }) => (
                              <DatePicker
                                className="form-control"
                                selected={getValues("dateSupport") ? new Date(getValues("dateSupport")) : null}
                                onChange={(e: Date) => {
                                  onChange(String(e?.getFullYear()));
                                  handleIsFormValid(String(e?.getFullYear()));
                                  handleIsStepOneValid();
                                }}
                                maxDate={new Date()}
                                placeholderText={props.t("expo_modale.label_date")}
                                dateFormat="yyyy"
                                showYearPicker
                              />
                            )}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="6" md="6">
                        <FormGroup className="m-b-30">
                          <Label id="country" className="form-label">
                            {props.t("expo_modale.label_country")}*
                          </Label>
                          <Typeahead
                            id="country-typeahead"
                            clearButton
                            defaultSelected={props.exposition ? props.exposition.listCountry : []}
                            labelKey={selectedLanguage === "en" ? "titleAnglais" : "titleFrancais"}
                            multiple={false}
                            options={listOptionsCountry}
                            placeholder={props.t("expo_modale.label_country")}
                            onChange={handleChangeCountry}
                            onBlur={() => countryRef.current?.blur()}
                            ref={countryRef}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="12" md="12">
                        <FormGroup className="m-b-30">
                          <Label id="thematic" className="form-label">
                            {props.t("expo_modale.label_thematic")}*
                          </Label>
                          <Typeahead
                            id="thematic-typeahead"
                            defaultSelected={props.exposition ? props.exposition.listThematic : []}
                            labelKey={selectedLanguage === "en" ? "titleAnglais" : "titleFrancais"}
                            multiple={true}
                            options={listOptionsThematic}
                            placeholder={props.t("expo_modale.label_thematic")}
                            onChange={handleChangeThematic}
                            onBlur={() => thematicRef.current?.blur()}
                            ref={thematicRef}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </>
                ) : activeStep === 1 ? (
                  <Row>
                    <Col sm="12" md="12">
                      <FormGroup className="m-b-30">
                        <Label id="country" className="form-label">
                          {props.t("expo_modale.description_fr")}
                        </Label>
                        <textarea
                          {...register("descriptionFr")}
                          required
                          onChange={event => {
                            setValue("descriptionFr", event.target.value);
                            handleIsFormValid(event.target.value);
                          }}
                          maxLength={255}
                          className="form-control"
                          placeholder={props.t("expo_modale.description_fr")}
                        ></textarea>
                      </FormGroup>
                    </Col>
                    <Col sm="12" md="12">
                      <FormGroup className="m-b-30">
                        <Label id="country" className="form-label">
                          {props.t("expo_modale.description_en")}
                        </Label>
                        <textarea
                          {...register("descriptionEn")}
                          required
                          onChange={event => {
                            setValue("descriptionEn", event.target.value);
                            handleIsFormValid(event.target.value);
                          }}
                          maxLength={255}
                          className="form-control"
                          placeholder={props.t("expo_modale.description_en")}
                        ></textarea>
                      </FormGroup>
                    </Col>
                  </Row>
                ) : (
                  <>
                    <Row className={styles["zone-step-exposition"] + " m-10"}>
                      <ImageUploading multiple value={images} onChange={onChange} maxNumber={maxNumber} dataURLKey="data_url">
                        {({ imageList, onImageUpload, onImageRemoveAll, onImageUpdate, onImageRemove, isDragging, dragProps }) => (
                          // write your building UI
                          <>
                            <Col sm="12" md="12" xl="12" className={styles["zone-upload-images__drop-zone"]}>
                              <DragSortableList ref={refDragSortable} items={listOfImages} placeholder={placeholder} onSort={onSortedListOfImg} dropBackTransitionDuration={0.3} type="horizontal" />
                            </Col>
                            <section className={`${styles["zone-actions__btn-upload-refresh"]}`}>
                              <span className={styles["zone-actions__btn-upload"]} style={isDragging ? { color: "red" } : undefined} onClick={onImageUpload} {...dragProps}>
                                <i className="fa fa-cloud-upload"></i>&nbsp; {props.t("expo_modale.label_select_images")}
                              </span>
                              <span
                                className={`${styles["zone-actions__btn-refresh"]}`}
                                onClick={() => {
                                  setListOfImages([]);
                                  setImages([]);
                                  dropZoneIsValid([]);
                                }}
                                {...dragProps}
                              >
                                <i className="fa fa-refresh"></i>&nbsp; {props.t("expo_modale.empty_zone_select_images")}
                              </span>
                            </section>
                          </>
                        )}
                      </ImageUploading>
                    </Row>
                  </>
                )}
                <ModalFooter className={styles["footer-style"] + " m-t-30 p-b-0 p-t-5"}>
                  <>
                    <Col md={12}>
                      <Button className={styles["back"] + " float-left"} onClick={props.closeToggle}>
                        Annuler
                      </Button>

                      {activeStep === steps.length - 1 ? (
                        <Button
                          className={styles["submit"]}
                          disabled={listOfImages.length === 0}
                          onClick={() => {
                            _handleSubmit(getValues());
                          }}
                          sx={{ mr: 1 }}
                        >
                          {props.t("button_submit")}
                        </Button>
                      ) : (
                        <Button color="success" disabled={activeStep === 0 && !isFomrStepOneValid} className={styles["submit"]} onClick={handleNext}>
                          {props.t("button_next")}
                        </Button>
                      )}
                      {activeStep !== 0 && (
                        <Button className={styles["cancel"]} onClick={handleBack} sx={{ mr: 1 }}>
                          {props.t("button_previous")}
                        </Button>
                      )}
                    </Col>
                  </>
                </ModalFooter>
              </div>
            </Form>
          </Fragment>
          <Typography sx={{ mt: 2, mb: 1 }}></Typography>
        </React.Fragment>
      )}
    </Box>
  );
};

export default translate(UpdateImagesGallery);
